import { Badge } from '@/components/ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { EVERGREEN_FAQS } from './retreatsData';

export const RetreatsFAQ = () => (
  <section id="faq" className="py-20 px-6 bg-cream" data-testid="retreats-faq-section">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <Badge className="bg-terracotta/10 text-terracotta mb-4">Questions?</Badge>
        <h2 className="font-heading text-4xl font-bold text-forest">
          Retreat FAQ
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {EVERGREEN_FAQS.map((faq, i) => (
          <AccordionItem key={faq.question} value={`faq-${i}`} className="bg-white rounded-xl border border-sand px-6" data-testid={`retreats-faq-item-${i}`}>
            <AccordionTrigger className="font-heading text-lg text-forest hover:no-underline py-4 text-left">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-gray-600 pb-4">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
